module.exports = __webpack_public_path__ + "img/gatetopay-otm.68db79fb.svg";